import Typography from '@material-ui/core/Typography';
import { Grid, ListItemIcon, ListItemText, Paper, makeStyles, } from '@material-ui/core';
import patchNotes from "./patch-notes.json";
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import BugReportOutlinedIcon from '@material-ui/icons/BugReportOutlined';
const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    overflow: 'hidden',
    padding: theme.spacing(0, 3),
  },
  paper: {
    maxWidth: "50%",
    margin: `${theme.spacing(1)}px auto`,
    padding: theme.spacing(2),
  },
}));

type IPatchNotes = {
  version: string;
  news: string[];
  changes: string[];
  removes: string[];
};

export const PatchNotes = () => {
  const classes = useStyles();
  const patchNotesData: IPatchNotes[] = patchNotes;
  return (
    <div className={classes.root}>

      <Paper className={classes.paper}>

        <Grid wrap="nowrap" spacing={3}>
          {patchNotesData.map((item) => {

            return <Grid xs={12}>
              <Typography paragraph variant="h3">Versão: {item.version} </Typography>
              <Typography variant="h4" >Novidades: </Typography>
              <List>
                {item.news.map((item) => {
                  return <ListItem>
                    <ListItemText>{item}</ListItemText>
                  </ListItem>
                })}
              </List>
              <Typography variant="h4">Alterações: </Typography>
              <List>
                {item.changes.map((item) => {
                  return <ListItem>
                    <ListItemText>{item}</ListItemText>
                  </ListItem>
                })}
              </List>
              <Typography variant="h4">Correções: </Typography>
              <List>
                {item.removes.map((item) => {
                  return <ListItem>
                    <ListItemText>{item}</ListItemText>
                  </ListItem>
                })}
              </List>
              <hr />
            </Grid>
          })}
        </Grid>
      </Paper>
    </div>
  )
}